// extracted by mini-css-extract-plugin
export default {"content":"Statistics_content__KO+Y6","tabs":"Statistics_tabs__VVLBD"};